const DEFAULT_APP_NAME = 'Workbeam'

/** Browser tab title: "Page · AppName" or just app name when no page segment. */
export function formatDocumentTitle(pageSegment: string | undefined, applicationName: string): string {
  const app = (applicationName?.trim() || DEFAULT_APP_NAME).slice(0, 60)
  const page = pageSegment?.trim()
  if (page) {
    return `${page} · ${app}`
  }
  return app
}
